// extracted by mini-css-extract-plugin
module.exports = {"classSectionTable":"style-module__classSectionTable___1y62T","noData":"style-module__noData___1AjRE","loading":"style-module__loading___3pCmC"};